var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgServiceFeedback = function SvgServiceFeedback(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#691B33",
    strokeWidth: 2,
    d: "M12.5 19H19a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v1.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#691B33",
    strokeWidth: 2,
    d: "M11 5v2h2V5M5.594 12.071l.906-1.824.906 1.824a1.5 1.5 0 0 0 1.124.817l2.014.298L9.09 14.61l.67.684-.67-.684a1.5 1.5 0 0 0-.43 1.321L9 17.94l-1.806-.943a1.5 1.5 0 0 0-1.388 0l.463.887-.463-.887L4 17.94l.34-2.008a1.5 1.5 0 0 0-.43-1.32l-1.454-1.426 2.014-.298a1.5 1.5 0 0 0 1.124-.817Z"
  })));
};
export default SvgServiceFeedback;